<ng-container *ngrxLet="{ activeLanguage: activeLanguage$ } as vm">
    <link rel="stylesheet" href="competition.component.scss" />
    <div class="grid header">
        <div class="main-section">
            <h1>
                {{ "dtmMainPageLib.subpage.kpo.competition.title" | transloco }}
            </h1>
            <p class="message">
                {{ "dtmMainPageLib.subpage.kpo.competition.description" | transloco }}
            </p>
        </div>
    </div>

    <dtm-main-page-lib-kpo-logos [activeLanguage]="vm.activeLanguage" />

    <div class="sections-container">
        <div class="grid purpose">
            <h2>{{ "dtmMainPageLib.subpage.kpo.competition.purposeTitle" | transloco }}</h2>
            <img ngSrc="/assets/images/kpo/competition.svg" alt="" height="372" width="460" />
            <div class="description">
                <p class="message">
                    {{ "dtmMainPageLib.subpage.kpo.competition.purposeDescriptionFirstParagraph" | transloco }}
                </p>
                <p class="message">
                    {{ "dtmMainPageLib.subpage.kpo.competition.purposeDescriptionSecondParagraph" | transloco }}
                </p>
                <button type="button" class="button-secondary" (click)="scrollToFiles()">
                    {{ "dtmMainPageLib.subpage.kpo.competition.purposeDocumentsButtonLabel" | transloco }}
                </button>
            </div>
        </div>

        <div class="grid benefits">
            <h2>{{ "dtmMainPageLib.subpage.kpo.competition.benefits.title" | transloco }}</h2>
            <ul>
                <li>
                    <img ngSrc="assets/images/kpo/bulb.svg" alt="laptop" height="84" width="85" />
                    <p>{{ "dtmMainPageLib.subpage.kpo.competition.benefits.innovationSupportLabel" | transloco }}</p>
                </li>
                <li>
                    <img ngSrc="assets/images/kpo/chart.svg" alt="laptop" height="84" width="84" />
                    <p>{{ "dtmMainPageLib.subpage.kpo.competition.benefits.localEconomyAttractivenessLabel" | transloco }}</p>
                </li>
                <li>
                    <img ngSrc="assets/images/kpo/money.svg" alt="laptop" height="84" width="85" />
                    <p>{{ "dtmMainPageLib.subpage.kpo.competition.benefits.newBusinessOpportunitiesLabel" | transloco }}</p>
                </li>
                <li>
                    <img ngSrc="assets/images/kpo/spectrum.svg" alt="laptop" height="84" width="85" />
                    <p>{{ "dtmMainPageLib.subpage.kpo.competition.benefits.droneServicesExpansionLabel" | transloco }}</p>
                </li>
                <li>
                    <img ngSrc="assets/images/kpo/shield.svg" alt="laptop" height="84" width="84" />
                    <p>{{ "dtmMainPageLib.subpage.kpo.competition.benefits.safeDynamicFlightsLabel" | transloco }}</p>
                </li>
                <li>
                    <img ngSrc="assets/images/kpo/student-cap.svg" alt="laptop" height="84" width="85" />
                    <p>{{ "dtmMainPageLib.subpage.kpo.competition.benefits.professionalQualificationImprovementLabel" | transloco }}</p>
                </li>
            </ul>
        </div>

        <div class="grid participants">
            <div class="section">
                <div class="image-container" [ngSwitch]="vm.activeLanguage">
                    <img *ngSwitchDefault ngSrc="/assets/images/kpo/map_pl.svg" alt="" height="576" width="562" />
                    <img *ngSwitchCase="'en'" ngSrc="/assets/images/kpo/map_en.svg" alt="" height="576" width="562" />
                </div>
                <div class="section-info">
                    <h2>{{ "dtmMainPageLib.subpage.kpo.competition.participants.title" | transloco }}</h2>
                    <img ngSrc="assets/images/kpo/arrow.svg" width="84" height="85" alt="" />
                    <h3>{{ "dtmMainPageLib.subpage.kpo.competition.participants.municipalitiesLabel" | transloco }}</h3>
                    <p>{{ "dtmMainPageLib.subpage.kpo.competition.participants.municipalitiesDescription" | transloco }}</p>
                    <img ngSrc="assets/images/kpo/arrow.svg" width="84" height="85" alt="" />
                    <h3>{{ "dtmMainPageLib.subpage.kpo.competition.participants.municipalConsortiaLabel" | transloco }}</h3>
                    <p>{{ "dtmMainPageLib.subpage.kpo.competition.participants.municipalConsortiaDescription" | transloco }}</p>
                    <img ngSrc="assets/images/kpo/arrow.svg" width="84" height="85" alt="" />
                    <h3>{{ "dtmMainPageLib.subpage.kpo.competition.participants.publicPrivateConsortiaLabel" | transloco }}</h3>
                    <p>{{ "dtmMainPageLib.subpage.kpo.competition.participants.publicPrivateConsortiaDescription" | transloco }}</p>
                </div>
            </div>
        </div>

        <div class="grid winner-selection">
            <h2>{{ "dtmMainPageLib.subpage.kpo.competition.competitionWinnerSelectionMethod.title" | transloco }}</h2>
            <div class="stage">
                <h3>{{ "dtmMainPageLib.subpage.kpo.competition.competitionWinnerSelectionMethod.stageOne.title" | transloco }}</h3>
                <p
                    [innerHTML]="
                        'dtmMainPageLib.subpage.kpo.competition.competitionWinnerSelectionMethod.stageOne.purposeDescription' | transloco
                    "
                ></p>
                <h4>
                    {{ "dtmMainPageLib.subpage.kpo.competition.competitionWinnerSelectionMethod.stageOne.goalQuestionLabel" | transloco }}
                </h4>
                <p
                    [innerHTML]="
                        'dtmMainPageLib.subpage.kpo.competition.competitionWinnerSelectionMethod.stageOne.goalDescription' | transloco
                    "
                ></p>
                <h4>
                    {{
                        "dtmMainPageLib.subpage.kpo.competition.competitionWinnerSelectionMethod.stageOne.verificationQuestionLabel"
                            | transloco
                    }}
                </h4>
                <p
                    [innerHTML]="
                        'dtmMainPageLib.subpage.kpo.competition.competitionWinnerSelectionMethod.stageOne.verificationDescription'
                            | transloco
                    "
                ></p>
            </div>
            <div class="stage">
                <h3>{{ "dtmMainPageLib.subpage.kpo.competition.competitionWinnerSelectionMethod.stageTwo.title" | transloco }}</h3>
                <p
                    [innerHTML]="
                        'dtmMainPageLib.subpage.kpo.competition.competitionWinnerSelectionMethod.stageTwo.purposeDescription' | transloco
                    "
                ></p>
                <h4>
                    {{
                        "dtmMainPageLib.subpage.kpo.competition.competitionWinnerSelectionMethod.stageTwo.verificationQuestionLabel"
                            | transloco
                    }}
                </h4>
                <p
                    [innerHTML]="
                        'dtmMainPageLib.subpage.kpo.competition.competitionWinnerSelectionMethod.stageTwo.verificationDescription'
                            | transloco
                    "
                ></p>
                <h4>
                    {{
                        "dtmMainPageLib.subpage.kpo.competition.competitionWinnerSelectionMethod.stageTwo.scoringSystemQuestionLabel"
                            | transloco
                    }}
                </h4>
                <p
                    [innerHTML]="
                        'dtmMainPageLib.subpage.kpo.competition.competitionWinnerSelectionMethod.stageTwo.scoringSystemDescription'
                            | transloco
                    "
                ></p>
            </div>
        </div>

        <div class="grid criteria">
            <h2>{{ "dtmMainPageLib.subpage.kpo.competition.evaluationCriteria.title" | transloco }}</h2>
            <ul>
                <li>
                    <p>
                        {{ "dtmMainPageLib.subpage.kpo.competition.evaluationCriteria.locationAndAirspaceOrganizationLabel" | transloco }}
                    </p>
                    <ul>
                        <li>{{ "dtmMainPageLib.subpage.kpo.competition.evaluationCriteria.airspaceAvailabilityText" | transloco }}</li>
                        <li>{{ "dtmMainPageLib.subpage.kpo.competition.evaluationCriteria.aviationSafetyText" | transloco }}</li>
                    </ul>
                </li>
                <li>
                    <p>{{ "dtmMainPageLib.subpage.kpo.competition.evaluationCriteria.marketOpinionLabel" | transloco }}</p>
                    <ul>
                        <li>{{ "dtmMainPageLib.subpage.kpo.competition.evaluationCriteria.locationAttractivenessText" | transloco }}</li>
                    </ul>
                </li>
                <li>
                    <p>{{ "dtmMainPageLib.subpage.kpo.competition.evaluationCriteria.infrastructureLabel" | transloco }}</p>
                    <ul>
                        <li>{{ "dtmMainPageLib.subpage.kpo.competition.evaluationCriteria.trackingInfrastructureQuality" | transloco }}</li>
                        <li>{{ "dtmMainPageLib.subpage.kpo.competition.evaluationCriteria.emergencyLandingSites" | transloco }}</li>
                    </ul>
                </li>
                <li>
                    <p>{{ "dtmMainPageLib.subpage.kpo.competition.evaluationCriteria.populationAndOtherPropertiesLabel" | transloco }}</p>
                    <ul>
                        <li>{{ "dtmMainPageLib.subpage.kpo.competition.evaluationCriteria.areaSizeText" | transloco }}</li>
                        <li>{{ "dtmMainPageLib.subpage.kpo.competition.evaluationCriteria.proximityToUrbanCentersText" | transloco }}</li>
                        <li>{{ "dtmMainPageLib.subpage.kpo.competition.evaluationCriteria.populationDensityText" | transloco }}</li>
                    </ul>
                </li>
                <li>
                    <p>{{ "dtmMainPageLib.subpage.kpo.competition.evaluationCriteria.economicConditionsLabel" | transloco }}</p>
                    <ul>
                        <li>{{ "dtmMainPageLib.subpage.kpo.competition.evaluationCriteria.estimatedServiceDemandText" | transloco }}</li>
                        <li>{{ "dtmMainPageLib.subpage.kpo.competition.evaluationCriteria.participantExperienceTExt" | transloco }}</li>
                        <li>
                            {{ "dtmMainPageLib.subpage.kpo.competition.evaluationCriteria.additionalIdeasAndDeclarationsText" | transloco }}
                        </li>
                    </ul>
                </li>
            </ul>
        </div>

        <div class="grid stage">
            <h2>{{ "dtmMainPageLib.subpage.kpo.competition.stages.stageOne.title" | transloco }}</h2>
            <ol>
                <li>
                    <p class="date">{{ "dtmMainPageLib.subpage.kpo.competition.stages.stageOne.dates.submissionPeriod" | transloco }}</p>
                    <h3>{{ "dtmMainPageLib.subpage.kpo.competition.stages.stageOne.steps.submission" | transloco }}</h3>
                    <p>{{ "dtmMainPageLib.subpage.kpo.competition.stages.stageOne.submissionInstructions" | transloco }}</p>
                </li>
                <li>
                    <p class="date">{{ "dtmMainPageLib.subpage.kpo.competition.stages.stageOne.dates.analysisDeadline" | transloco }}</p>
                    <h3>{{ "dtmMainPageLib.subpage.kpo.competition.stages.stageOne.steps.analysis" | transloco }}</h3>
                    <p>{{ "dtmMainPageLib.subpage.kpo.competition.stages.stageOne.evaluationInstructions" | transloco }}</p>
                </li>
                <li>
                    <p class="date">{{ "dtmMainPageLib.subpage.kpo.competition.stages.stageOne.dates.resultsDeadline" | transloco }}</p>
                    <h3>{{ "dtmMainPageLib.subpage.kpo.competition.stages.stageOne.steps.results" | transloco }}</h3>
                    <p>{{ "dtmMainPageLib.subpage.kpo.competition.stages.stageOne.resultsInformation" | transloco }}</p>
                    <a routerLink="/nrp/competition" class="button-secondary">
                        {{ "dtmMainPageLib.subpage.kpo.competition.stages.stageOne.websiteLinkText" | transloco }}
                    </a>
                </li>
            </ol>
        </div>

        <div class="grid stage">
            <h2>{{ "dtmMainPageLib.subpage.kpo.competition.stages.stageTwo.title" | transloco }}</h2>
            <ol>
                <li>
                    <p class="date">{{ "dtmMainPageLib.subpage.kpo.competition.stages.stageTwo.dates.submissionPeriod" | transloco }}</p>
                    <h3>{{ "dtmMainPageLib.subpage.kpo.competition.stages.stageTwo.steps.submission" | transloco }}</h3>
                    <p>{{ "dtmMainPageLib.subpage.kpo.competition.stages.stageTwo.submissionInstructions" | transloco }}</p>
                </li>
                <li>
                    <p class="date">{{ "dtmMainPageLib.subpage.kpo.competition.stages.stageTwo.dates.votingPeriod" | transloco }}</p>
                    <h3>{{ "dtmMainPageLib.subpage.kpo.competition.stages.stageTwo.steps.voting" | transloco }}</h3>
                    <p>{{ "dtmMainPageLib.subpage.kpo.competition.stages.stageTwo.votingInstructions" | transloco }}</p>
                </li>
                <li>
                    <p class="date">{{ "dtmMainPageLib.subpage.kpo.competition.stages.stageTwo.dates.resultsDeadline" | transloco }}</p>
                    <h3>{{ "dtmMainPageLib.subpage.kpo.competition.stages.stageTwo.steps.results" | transloco }}</h3>
                    <p>{{ "dtmMainPageLib.subpage.kpo.competition.stages.stageTwo.resultsInformation" | transloco }}</p>
                </li>
            </ol>
        </div>

        <div class="grid submission-instruction">
            <div>
                <h4>{{ "dtmMainPageLib.subpage.kpo.competition.submissionInstructions.title" | transloco }}</h4>
                <a href="mailto:{{ COMPETITION_EMAIL }}" class="button-secondary">{{ COMPETITION_EMAIL }}</a>
                <p [innerHTML]="'dtmMainPageLib.subpage.kpo.competition.submissionInstructions.note' | transloco"></p>
            </div>
        </div>

        <dtm-main-page-lib-info
            [headerText]="'dtmMainPageLib.subpage.kpo.moreInfo.title' | transloco"
            [link]="BROCHURE_FILE"
            [linkText]="'dtmMainPageLib.subpage.kpo.moreInfo.brochureLinkText' | transloco"
            isDownload
        ></dtm-main-page-lib-info>

        <dtm-main-page-lib-kpo-registered-entities />
        <dtm-main-page-lib-kpo-files />
    </div>
</ng-container>
